import { Grid, Tabs, Tab } from "@pankod/refine-mui";

import CustomTabPanel from "components/CustomTabPanel";
import useTabs from "hooks/useTabs";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import PrezziarioSelector from "components/PrezziarioSelector";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
  prezziari,
  setPrezziari,
  emptyPrezziario,
}) {
  const [tabValue, handleChange, defProps] = useTabs(0);

  const enumDiscountsType = [
    { label: "Percentuale", value: "percent" },
    { label: "Valore Assoluto", value: "flat" },
  ];

  const fields = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      localized: true,
    },
    {
      label: "Descrizione",
      name: "description",
      required: false,
      type: "text",
      lines: 4,
      localized: true,
    },
    {
      label: "Disponibilità",
      name: "availability",
      required: true,
      type: "number",
    },
    {
      label: "Pernotto minimo",
      name: "minStay",
      required: true,
      type: "number",
      defaultValue: 1,
      md: 6,
    },
    {
      label: "Anticipo minimo prenotazione",
      name: "minAdvance",
      required: false,
      defaultValue: 0,
      type: "number",
      md: 6,
    },
    {
      label: "Rimborsabile",
      name: "refundable",
      required: true,
      type: "switch",
    },
    {
      label: "Cancellabile entro",
      name: "cancel_release",
      required: false,
      type: "number",
      defaultValue: 0,
      disabled: getValues("refundable") == true ? false : true,
    },
  ];

  const fieldsSconti = [
    {
      label: "Early Bird",
      type: "title",
      variant: "h6",
    },
    {
      label: "Sconto",
      name: "early_bird_discount",
      required: false,
      type: "number",
      defaultValue: 0,
      md: 4,
    },
    {
      label: "Minimo di giorni in anticipo",
      name: "early_bird_days",
      required: false,
      type: "number",
      defaultValue: 0,
      md: 4,
    },
    {
      label: "Tipologia di sconto",
      name: "early_bird_discount_type",
      options: enumDiscountsType,
      required: false,
      defaultValue: enumDiscountsType[0].value,
      type: "select",
      md: 4,
    },
    { type: "divider" },
    {
      label: "Last minute",
      type: "title",
      variant: "h6",
    },
    {
      label: "Sconto",
      name: "last_minute_discount",
      required: false,
      type: "number",
      defaultValue: 0,
      md: 4,
    },
    {
      label: "N giorni dal checkin",
      name: "last_minute_days",
      required: false,
      type: "number",
      defaultValue: 0,
      md: 4,
    },
    {
      label: "Tipologia di sconto",
      name: "last_minute_discount_type",
      options: enumDiscountsType,
      required: false,
      defaultValue: enumDiscountsType[0].value,
      type: "select",
      md: 4,
    },
  ];

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange}>
        <Tab label="Informazioni generali" {...defProps(0)} />
        <Tab label="Gestione prezzi" {...defProps(1)} />
        <Tab label="Gestione scontistiche" {...defProps(2)} />
      </Tabs>

      <CustomTabPanel value={tabValue} index={0}>
        <Grid container spacing={2}>
          {fields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <Grid container spacing={2}>
          <PrezziarioSelector
            prezziari={prezziari}
            setPrezziari={setPrezziari}
            emptyPrezziario={emptyPrezziario}
          />
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={2}>
        <Grid container spacing={2}>
          {fieldsSconti.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
    </>
  );
}
